module.exports = __webpack_public_path__ + "static/media/bike.e474a98b.jpg";